'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class evladmeliDataModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'applicationTime':
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}

	getQuestion(id){
		if(typeof(this.questions[id]) === 'undefined'){
			return null;
		}
		return this.questions[id];
	}
	
	isQInstruction(id){
		let q = this.getQuestion(id);
		if(!q){
			return false;
		}
		if(!q.instruction || q.instruction === ''){
			return false;
		}
		return true;
	}
	
	getQuestionValue(id){
		let q = this.getQuestion(id);
		if(!q){
			return null;
		}
		if(q.value === ''){
			return '';
		}
		let classif = this.s('jsDataService').get('cfgClassif');
		let classifName = 'yesnonot';
		if(id == 'p1qf' || id == 'p2qf'){
			classifName = 'yesno';
		}
		if(classif && typeof(classif[classifName]) !== 'undefined'){
			let v = this.s('$filter')('filter')(classif[classifName], {id: q.value}, true);
			if(v.length > 0){
				return v[0].title;
			}
		}
		return '';
	}
	
}
